import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addProduct, getTotals } from '../redux/cartRedux';
import { publicRequest } from './../requestMethods';
import ProductPanel from '../components/ProductPanel';
import { addFavorite, removeFavourite } from '../redux/favRedux';

// const PF = 'https://ecommerce-api-l3as.onrender.com/images/';

// const Panel = ({ product, handleAddCart }) => (
//   <article className="group">
//     <div className=" relative h-48 flex justify-center rounded bg-gray-200 ">
//       <div className="text-xl absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out">
//         <Like props={product} />
//       </div>
//       <img
//         alt={product.name}
//         className="max-h-full max-w-full rounded object-cover"
//         src={product.img.startsWith('product') ? PF + product.img : product.img}
//       />
//       <div className="absolute -bottom-2 left-50 w-20 h-20 rounded transition-all duration-500 ease-in-out opacity-0 group-hover:opacity-100  flex justify-center items-center bg-opacity-30  cursor-pointer">
//         <button
//           className="cursor-pointer  px-5 py-3 text-white bg-blue-500 outline-none"
//           onClick={() => handleAddCart(product, product.color[0], product.size[0])}
//         >
//           <i className="text-2xl fa fa-shopping-bag"></i>
//         </button>
//         <Link to={`/products/${product._id}`} className="cursor-pointer  px-5 py-3  bg-white">
//           <i className="text-2xl fa fa-share"></i>
//         </Link>
//       </div>
//     </div>
//     <footer className="flex justify-between flex-col mt-4 capitalize">
//       <h6 className="tracking-wider">{product.title}</h6>
//       <p className="text-blue-500 tracking-widest">${product.price}</p>
//     </footer>
//   </article>
// );

const Home = () => {
  const [products, setProducts] = useState([]);
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const res = await publicRequest.get(`/products`);
        setProducts(res.data.data);
      } catch (err) {
        console.log(err);
      }
    };
    getProducts();
  }, []);

  useEffect(() => {
    dispatch(getTotals());
  }, [cart, dispatch]);

  const handleAddCart = (product, color, size) => {
    const { desc, categories, ...item } = product;
    dispatch(addProduct({ ...item, quantity, color, size }));
  };

  const handleAddFav = (product, color, size) => {
    const { desc, categories, ...item } = product;
    dispatch(addFavorite({ ...item, quantity, color, size }));
  };

  return (
    <>
      {/* SHOWCASE */}
      <section id="showcase" className="flex justify-center">
        <div className="tw-container grid lg:grid-cols-2 place-items-center gap-x-32">
          <article>
            <h1 className="tracking-wider font-bold text-4xl md:text-5xl">
              Design Your
              <br />
              Comfort Zone
            </h1>
            <p className="mt-8 max-w-lg leading-loose ">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iusto, at sed omnis corporis
              doloremque possimus velit! Repudiandae nisi odit, aperiam odio ducimus, obcaecati
              libero et quia tempora excepturi quis alias?
            </p>
            <Link
              to="/products"
              className="btn px-6 py-3 bg-blue-500 text-white w-full md:w-max text-center mt-8"
            >
              Shop Now
            </Link>
          </article>
          {/* <article id="showcase-image" className="relative hidden lg:block">
            <img
              alt="dining-room-example"
              style={{
                height: '550px',
              }}
              className="object-cover bg-gray-100 w-full rounded-md"
              src="https://react-course-comfy-sloth-store.netlify.app/static/media/hero-bcg.a876f19f.jpeg"
            />
            <img
              alt="media-shelves-room"
              className="z-10 bg-gray-100 transform -translate-x-2/4 absolute left-0 bottom-0  w-5/12 h-40 rounded-md"
              src="https://dl.airtable.com/.attachments/d42fd61c4d1ae2a02afe29114bd0fef3/d312dda5/product-2.jpg"
            />
          </article> */}
        </div>
      </section>
      {/* Benefit Section */}
      <section id="benefits" className="py-16">
        <div className="tw-container grid grid-cols-1 lg:grid-cols-3 place-items-start lg:place-items-center  gap-10 lg:gap-32 bg-gray-50 shadow-lg py-5 px-5 lg:px-0 border-t-2 border-gray-300 border-opacity-30 rounded">
          <div>
            <div className="flex gap-5">
              <div className="text-4xl text-blue-600">
                <i className="fas fa-shipping-fast"></i>
              </div>
              <div className="text-xl text-gray-900">
                <p className="font-bold">Free Shipping</p>
                <p className="text-lg text-gray-800">For all order over RS. 100</p>
              </div>
            </div>
          </div>
          <div>
            <div className="flex gap-5">
              <div className="text-4xl text-blue-600">
                <i className="far fa-clock"></i>
              </div>
              <div className="text-xl text-gray-900">
                <p className="font-bold">Delivery On Time</p>
                <p className="text-lg text-gray-800">Fast delivery of goods</p>
              </div>
            </div>
          </div>
          <div>
            <div className="flex gap-5">
              <div className="text-4xl text-blue-600">
                <i className="fa fa-credit-card"></i>
              </div>
              <div className="text-xl text-gray-900">
                <p className="font-bold">Secure Payment</p>
                <p className="text-lg text-gray-800">100% secure payment</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CATEGORY SECTION */}
      <section className="pb-16">
        <div className="mb-10">
          <h2 className="text-center font-bold text-3xl lg:text-4xl ">Categories</h2>
          <div className="mt-3 w-24 h-1 bg-blue-400 mx-auto" />
        </div>
        <div className="tw-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 place-items-center gap-10">
          <Link to={{ pathname: '/products', state: { category: 'man' } }}>
            <div className="shadow-lg rounded w-full text-center">
              <div className="">
                <img
                  className="rounded h-36"
                  src="https://my-online-shop.netlify.app/static/banner-1-d3b8382fbef3cff2c61c0d2bd5f279b0.jpg"
                  alt=""
                />
                <div className="py-3">
                  <h4>Men’s</h4>
                </div>
              </div>
            </div>
          </Link>
          <Link to={{ pathname: '/products', state: { category: 'women' } }}>
            <div className="shadow-lg rounded w-full text-center">
              <div className="">
                <img
                  className="rounded h-36"
                  src="https://my-online-shop.netlify.app/static/banner-2-53c4054bae7bed9e6b18b5a068d50997.jpg"
                  alt=""
                />
                <div className="py-3">
                  <h4>Women’s</h4>
                </div>
              </div>
            </div>
          </Link>
          <Link to={{ pathname: '/products', state: { category: 'kid' } }}>
            <div className="shadow-lg rounded w-full text-center ">
              <div className="">
                <img
                  className="rounded h-36"
                  src="https://my-online-shop.netlify.app/static/banner-3-83f4b7aa13d6dc993c8d5258d07a9732.jpg"
                  alt=""
                />
                <div className="py-3">
                  <h4>Kid’s</h4>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </section>
      {/* Featured Products */}
      <section id="featured-products" className="bg-gray-100">
        <div className="tw-container py-14">
          <div>
            <h2 className="text-center font-bold text-3xl lg:text-4xl">Featured Products</h2>
            <div className="mt-3 w-24 h-1 bg-blue-400 mx-auto" />
          </div>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
            {products.map((product) => (
              <ProductPanel
                key={product._id}
                product={product}
                handleAddCart={handleAddCart}
                handleAddFav={handleAddFav}
              />
            ))}
          </div>
          <div className="flex justify-center mt-12">
            <Link
              to="/products"
              className="px-5 py-2 bg-blue-500 text-blue-50 font-semibold outline-none rounded-md tracking-wider"
            >
              All Products
            </Link>
          </div>
        </div>
      </section>
      {/* NEWSLETTER */}
      <section id="newsletter" className="py-4 md:py-8 lg:py-16 text-white">
        <div className="tw-container">
          <h2 className="font-bold">Join our newsletter and get 20% off</h2>
          <div className="grid grid-rows-2 lg:grid-rows-1 lg:grid-cols-2 items-center gap-x-32">
            <p className="leading-7 mt-8 max-w-lg opacity-60">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat sint unde quaerat
              ratione soluta veniam provident adipisci cumque eveniet tempore?
            </p>
            <form
              className="mt-6 md:mt-0 grid grid-cols-1 md:grid-cols-2 md:border-2 border-blue-500 rounded-md w-full max-w-lg  text-base md:text-lg lg:text-xl"
              style={{ gridTemplateColumns: '1fr auto' }}
            >
              <input
                className="bg-gray-100 border border-blue-400 md:bg-transparent md:border-0 px-3 py-2 outline-none"
                type="email"
                placeholder="Enter Email"
              />
              <button
                className="mt-4 md:mt-0 rounded-r btn-form bg-blue-500 text-white font-semibold "
                type="submit"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
